<template>
<div style="height:calc(100vh - 83px)">
  <div style="height:50px;" class="comm-settings-top-nav">
      <div class="justify-content-start" style="width:100%;">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb comm-settings-top-nav m-0">
            <li class="comm-icon-rtl">
               <back-button v-on:click.native="changeToSelectedBinComponent('show-bins')" style="position: relative;"></back-button>
            </li>
            <!-- <li class="breadcrumb-item"><a v-on:click="changeToSelectedBinComponent('show-bins')">Bins</a></li> -->
            <li class="breadcrumb-item active-text-nav-bar" aria-current="page">{{selectedBinId}}</li>
            </ol>
        </nav>
      </div>
    </div>
  <nav class="navbar navbar-expand-lg p-0">
        <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
            <div class="navbar-nav w-100 top-nav-bar">
                <a class="nav-item nav-link" @click="currentDiv ='BinBasicInfo'" :class="(currentDiv == 'BinBasicInfo')?'activeNav':'inactiveNav'">{{$t('Basic Info')}}</a>
                <a class="nav-item nav-link" v-show="!['proxy','archive'].includes(newBinInfo.bin_type)"
                 @click="currentDiv='BinWatchFolder'" :class="(currentDiv == 'BinWatchFolder')?'activeNav':'inactiveNav'">{{$t('Watch folder')}}</a>
                <a class="nav-item nav-link" v-show="['asset'].includes(newBinInfo.bin_type)"
                 @click="currentDiv='AdvancedOptions'" :class="(currentDiv == 'AdvancedOptions')?'activeNav':'inactiveNav'">{{$t('Advanced')}}</a>
            </div>
        </div>
    </nav>
    <div v-show="currentDiv == 'BinBasicInfo'">
    <div id="BinBasicInfo" class="tabcontent" style="overflow:auto;">
      <div style="height:80%">
      <table class="table bins-basic-info-table" style="background:transparent;overflow:auto;width: 90%;">
      <thead style="color: #eee">
       <tr>
          <th scope="col" style="width: 20%"></th>
          <th scope="col" style="width: 80%"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="key-div">{{$t('Bin ID')}} *</td>
          <td id="field_binid" class="value-div d-block m-0">
            <input type="text" id="binid_value" ref="binIdRef" placeholder="Enter Bin ID" v-model="newBinInfo.bin_id" class="rounded text-light comm-input-field-style"/>
            <span class="config-desc">{{$t('Is unique ID for the BIN and its non editable once it created')}}. </span>
          </td>
        </tr>
        <tr>
          <td class="key-div">{{$t('BinName')}} *</td>
          <td id="field_binname" class="value-div d-flex m-0">
             <input type="text" ref="binNameRef" id="binname_value" placeholder="Enter Bin Name" v-model="newBinInfo.bin_name" class="rounded text-light comm-input-field-style"/>
          </td>
        </tr>
        <tr>
          <td class="key-div">{{$t('Bin Type')}} *</td>
          <td class="value-div d-flex m-0">
              <Multiselect
              :value="selectedBinType"
              :options="binTypes"
              :searchable="false"
              :close-on-select="true"
              :allow-empty="false"
              deselectLabel=""
              selectLabel=""
              selectedLabel=""
              label="label"
              track-by="type"
              placeholder="Enter Bin Type"
              @select="onBinTypeChange($event)">
              <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
              <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
              </div>
              <span slot="noResult">No results.</span>
            </Multiselect>
          </td>
        </tr>
        <tr v-if="newBinInfo.bin_type == 'proxy'">
            <td class="key-div">{{$t('Preview URL')}}</td>
            <td id="field_preview_url" class="value-div d-flex m-0">
              <input type="text" id="preview_url_value" v-model="proxyInfo.preview_url" placeholder="asset,archive" class="rounded text-light comm-input-field-style"/>
            </td>
          </tr>
           <!-- <tr v-if="newBinInfo.bin_type == 'proxy'">
            <td class="key-div">{{$t('Supported Bin Types')}}</td>
            <td id="field_supported_bin_types" class="value-div d-flex m-0">
              <input type="text" id="supported_bin_types_value"  placeholder="Enter supported Bin types" v-model="proxyInfo.supported_bin_types" class="rounded text-light comm-input-field-style"/>
            </td>
        </tr> -->
        <tr v-if="newBinInfo.bin_type == 'deployment'">
          <td class="key-div">{{$t('Export Datewise')}}</td>
          <td class="value-div">
            <div class="custom-control custom-switch">
              <input type="checkbox" v-model="newBinInfo.datewise_export"
              class="custom-control-input" id="customSwitch3" :checked="newBinInfo.datewise_export === true">
              <label class="custom-control-label" for="customSwitch3">
                <span
                  v-if="newBinInfo.datewise_export == true"
                  class="text-success"
                  >{{$t('Enabled')}}
                </span>
                <span v-else class="text-danger">{{$t('Disabled')}}</span>
              </label>
            </div>
          </td>
        </tr>
      <!-- <tr style="#bbb">
        <td class="key-div p-2 align-middle" style="width:20%">Read Only</td>
        <td class="value-div d-flex m-0 p-2" style="width:80%;"><input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes">
        </td>
      </tr> -->
    </tbody>
  </table>
        <div class="pb-2" id="primary-credentails" style="width:90%">
          <div  style="display: inline-flex; width: 100%;">
          <button class="btn text-white p-0 pl-2" @click="showPrimaryCredentialSection = !showPrimaryCredentialSection">
            <svg v-show="showPrimaryCredentialSection" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
            </svg>
            <svg v-show="!showPrimaryCredentialSection" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
            </svg>
          </button>
          <!-- <h6 class="m-0 text-left" v-if="key == '1'">Primary Credentials</h6> -->
          <h6 class="ml-2 mr-2 text-left" style="width:90%">{{$t('Primary Credentials')}}</h6>
          </div>
          <bin-credentials v-show="showPrimaryCredentialSection" :strategyIndex=0 ref="primaryBinCredentails"></bin-credentials>
        </div>

        <div class="pb-2" id="secondary-credentails" style="width:90%">
          <div  style="display: inline-flex; width: 100%;">
          <button class="btn text-white p-0 pl-2" @click="showSecondaryCredentialSection = !showSecondaryCredentialSection">
            <svg v-show="showSecondaryCredentialSection" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
            </svg>
            <svg v-show="!showSecondaryCredentialSection" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
            </svg>
          </button>
          <!-- <h6 class="m-0 text-left" v-if="key == '1'">secondary Credentials</h6> -->
          <h6 class="ml-2 mr-2 text-left" style="width:90%">{{$t('Secondary Credentials')}}</h6>
          </div>
          <bin-credentials v-show="showSecondaryCredentialSection" :strategyIndex="1" ref="secondaryBinCredentails"></bin-credentials>
          
        </div>
      </div>
    </div>
    </div>
    <div v-show="currentDiv == 'BinWatchFolder'">
    <div id="BinWatchFolder" class="tabcontent" style="overflow:auto;">
      <table class="table bins-basic-info-table pl-4" style="background:transparent;overflow:auto;height:93%;display:block;width:100%">
    <thead style="color: #eee">
      <tr>
        <th scope="col" style="width: 20%"></th>
        <th scope="col" style="width: 80%"></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="key-div">{{$t('Watch Folder Status')}}</td>
        <td class="value-div"><div class="custom-control custom-switch">
          <input type="checkbox" v-model="watchFolderDetails.status" class="custom-control-input" id="customSwitch1"
          :checked="watchFolderDetails.status === 'active'">
          <label class="custom-control-label" for="customSwitch1">
            <span
              v-if="watchFolderDetails.status"
              class="text-success"
              >Active</span
            >
            <span v-else class="text-danger">{{$t('Inactive')}}</span></label
          >
        </div></td>
      </tr>
       <tr v-show="watchFolderDetails.status">
        <td class="key-div">{{$t('Watch Folder')}} *</td>
        <td class="value-div d-block m-0 w-100">
          <div style="width:100%;display:inline-block">
             <input type="text" v-model="watchPath" ref="watchFolderName" placeholder="Enter watch folder name" class="bg-transparent border rounded text-light comm-input-field-style" style="width:40% !important"/>
          </div>
          <span class="config-desc">{{$t('Folder name from which files are ingested to FUSION application')}}. </span>
          <!-- <input type="text" v-model="watchPath" class="bg-transparent border rounded text-light" style="width:35%"/> -->
        </td>
      </tr>
      <tr v-show="watchFolderDetails.status">
        <td class="key-div">{{$t('Out Folder')}} *</td>
        <td class="value-div d-block m-0 w-100">
          <div style="width:100%;display:inline-block">
            <input type="text" v-model="outPath" ref="outFolderName" placeholder="Enter out folder name"  class="bg-transparent border rounded text-light comm-input-field-style" style="width:40% !important"/>
          </div>
          <span class="config-desc">{{$t('Files from watch folder moved to Out folder on successful ingest')}}.</span>
          <!-- <input type="text" v-model="outPath" class="bg-transparent border rounded text-light" style="width:35%"/> -->
          <div style="margin:10px 0px">
            <div class="custom-control custom-switch">
              <input type="checkbox" v-model="watchFolderDetails.create_pass_path_datewise" class="custom-control-input" id="customSwitch2"
              :checked="watchFolderDetails.create_pass_path_datewise">
              <label class="custom-control-label" for="customSwitch2">{{$t('Datewise folder structure')}}</label>
            </div>
            <Multiselect
                  v-show="watchFolderDetails.create_pass_path_datewise == true"
                  v-model="watchPassPathDateStruct"
                  :options="watchPassPathDateStructOptions"
                  :searchable="false"
                  :close-on-select="true"
                  :allow-empty="false"
                  deselectLabel=""
                  selectLabel=""
                  selectedLabel=""
                  track_by="format"
                  label="label"
                  placeholder="Watch intervals"
                  style="margin-top:10px;width: 50% !important;">
                  <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                  <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                  </div>
                  <span slot="noResult">No results.</span>
            </Multiselect>
            <span v-show="watchFolderDetails.create_pass_path_datewise == true"
            class="config-desc">{{$t('Datewise folder format to ingest files in to FUSION application')}}. 
            </span>
          </div>
          <div>
            <div class="custom-control custom-switch">
              <input type="checkbox" v-model="watchFolderDetails.keep_watch_path_structure" class="custom-control-input" id="customSwitch3"
              :checked="watchFolderDetails.keep_watch_path_structure">
              <label class="custom-control-label" for="customSwitch3">{{$t('Keep watch path structure')}}</label>
            </div>
          </div>
        </td>
      </tr>
      <tr v-show="watchFolderDetails.status">
        <td class="key-div">Error Folder</td>
        <td class="value-div d-block m-0 w-100">
          <div style="width:35%;">{{errorPath}}</div>
          <span class="config-desc">{{$t('Files from watch folder moved to Error folder whenever if files extensions are not allowed')}}.   </span>
          <!-- <input type="text" v-model="errorPath" class="bg-transparent border rounded text-light" style="width:35%"/> -->
        </td>
      </tr>
      <tr v-show="watchFolderDetails.status">
        <td class="key-div">{{$t('Watch Intervel')}}</td>
        <td class="value-div d-block m-0" style="width:51%">
          <Multiselect
            v-model.number="watchInterval"
            :options="watchIntervals"
            :searchable="false"
            :close-on-select="true"
            :allow-empty="false"
            @select="onChange($event)"
            deselectLabel=""
            selectLabel=""
            selectedLabel=""
            placeholder="Watch intervals">
            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
            <span style="margin-inline-start:12px;">{{ scope.option }}</span>
            </div>
            <span slot="noResult">No results.</span>
          </Multiselect>
            <span class="config-desc">{{$t('Wait time (in Sec) to start next poling iteration on watch folder')}}. </span>
        </td>
      </tr>
      <tr v-show="watchFolderDetails.status">
        <td class="key-div">{{$t('Detect file types')}}</td>
        <td class="value-div m-0 d-inline-flex w-100 pb-0">
          <div class="d-inline-flex w-25">
            <input type="radio" value="include_list" v-model="fileTypesStrategy" class="bg-transparent border rounded text-light bigger-checkboxes" name="file type"/>
            <label style="position: relative;bottom: 1px;inset-inline-start:5px">{{$t('Include list')}}</label>
          </div>
          <div class="d-inline-flex w-25">
            <input type="radio" value="exclude_list" v-model="fileTypesStrategy" class="bg-transparent border rounded text-light bigger-checkboxes" name="file type"/>
            <label style="position: relative;bottom: 1px;inset-inline-start:5px">{{$t('Exclude list')}}</label>
          </div>
          <div class="d-inline-flex w-25">
            <input type="radio" value="regex_pattern" v-model="fileTypesStrategy" class="bg-transparent border rounded text-light bigger-checkboxes" name="file type"/>
            <label style="position: relative;bottom: 1px;inset-inline-start:5px">{{$t('Regexp')}}</label>
          </div>
        </td>
      </tr>
       <tr v-show="watchFolderDetails.status">
        <td class="key-div"></td>
        <td class="value-div d-block m-0 w-100 pt-0" style="width:100%;margin-inline-start:0px">
          <input type="text" v-model="supportedFileList" class="rounded text-light comm-input-field-style" placeholder="mp4,mpeg,mxf,mov" style="width:40%"/>
          <span class="config-desc">{{$t('Allowed file extensions to ingest in to FUSION application')}}. </span>
        </td>
      </tr>
       <tr v-show="watchFolderDetails.status">
        <td class="key-div">{{$t('Unique String')}}</td>
        <td class="value-div m-0 pb-0">
            <input type="checkbox" @click="appendUniqueString = !appendUniqueString" class="bg-transparent border rounded text-light bigger-checkboxes"/>
            <label style="position: relative;bottom: 10px;inset-inline-start:8px !important">{{$t('Attach unique string to make each file unique')}}</label>
        </td>
      </tr>
       <tr v-if="appendUniqueString && watchFolderDetails.status">
        <td class="key-div"></td>
        <td class="value-div m-0 d-inline-block w-100 pt-0">
          <div class="w-100" style="display:grid">
          <div class="d-inline-flex w-50">
            <input type="radio" value="sequence" v-model="uniqueStringStrategy" class="bg-transparent border rounded text-light bigger-checkboxes" name="Unique String"/>
            <label style="position: relative;bottom: 1px;inset-inline-start:5px">{{$t('Sequence number')}}</label>
          </div>
          <div class="d-inline-flex w-50">
            <input type="radio" value="timestamp" v-model="uniqueStringStrategy" class="bg-transparent border rounded text-light bigger-checkboxes" name="Unique String"/>
            <label style="position: relative;bottom: 1px;inset-inline-start:5px">{{$t('Date and timestamp')}}</label>
          </div>
          </div>
          <div class="config-desc">
           {{$t('Append string to make filename unique across the system')}}.
          </div>
        </td>
      </tr>
    </tbody>
      </table>
    </div>
    </div>
    <div v-show="currentDiv == 'AdvancedOptions'">
      <div id="AdvancedOptions" class="tabcontent" style="overflow:auto;">
        <table class="table bins-basic-info-table pl-4" style="background:transparent;overflow:auto;height:93%;display:block;width:100%">
          <thead style="color: #eee">
            <tr>
              <th scope="col" style="width: 20%"></th>
              <th scope="col" style="width: 80%"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="key-div"></td>
              <td class="value-div d-block m-0 w-100">
                <div>
                  <input type="checkbox" v-model="advancedOptions.enable_archive_trash" class="bg-transparent border rounded text-light bigger-checkboxes"/>
                  <label style="position: relative;bottom: 10px;inset-inline-start:5px !important">{{$t('Mark for delete after archive')}}</label>
                </div>
                <span class="config-desc">{{$t('Move files to trash folder after archive')}}. </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
     <div class="primary-btn-style">
    <button @click="addBin()" class="btn btn-outline-primary" data-v-198e7d7f="">
      {{$t('Save')}}
    </button>
      <button class="btn btn-outline-secondary mr-3" data-dismiss="modal"  v-on:click="changeToSelectedBinComponent('show-bins')">{{$t('Cancel')}}</button>
  </div>
</div>
</template>

<script>
import {mapActions} from "vuex"
import AddBinCredentails from "../bins/AddBinCredentials.vue"
import Utils from "../../components.utils.js";
import BackButton from "../core/backButton.vue";
import Multiselect from 'vue-multiselect';

export default {
  data() {
    return {
      currentDiv:'BinBasicInfo',
      supportedFileList:"",
      fileTypesStrategy:"include_list",
      uniqueStringStrategy:"sequence",
      // watchPath:"INBOX",
      // outPath:"ONAIR",
      watchPath:"",
      outPath:"",
      errorPath:"ERROR",
      watchInterval:10,
      appendUniqueString:false,
      advancedOptions:{
        enable_archive_trash: false
      },
      watchFolderDetails:{
        watch_interval:10,
         poll_strategy:{
           "include_list":["mp4,mpeg,mxf,mov,avi"],
           "strategy":"include_list"
         },
         status:false,
         create_pass_path_datewise:false,
         keep_watch_path_structure :false,
      },
      newBinInfo: {
        bin_type:"asset",
        watch_options:this.watchFolderDetails,
        datewise_export:false
      },
      selectedBinType:{label:"Asset",type:"asset"},
      binTypes:[
      {label:"Asset",type:"asset"},
      {label:"Archive",type:"archive"},
      {label:"Proxy",type:"proxy"},
      {label:"Target",type:"deployment"}
      ],
      proxyInfo:{
        "preview_url" : "https://10.10.10.1/proxy",
        "supported_bin_types":"asset,archive"
      },
      showPrimaryCredentialSection: true,
      showSecondaryCredentialSection: true,
      addPrimary:true,
      defaultBinCredentialCount:["1","2"],
      validPassword: true,
      validSecondaryPassword: true,
      secondaryValidBackupIp:true,
      validBackupIp:true,
      secondaryValidIp: true,
      validIp:true,
      passwordRegex: new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/),
      ipAddressRegex: new RegExp(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/),
      watchIntervals:[1,5,10,30,60,300],
      watchPassPathDateStruct:{label:"Jan-17/01-01-2018", format:"%b-%y@%d-%m-%Y"},
      watchPassPathDateStructOptions:[
        {label:"Jan-18/01-01-2018", format:"%b-%y@%d-%m-%Y"},
        {label:"Jan-18/01-01-18", format:"%b-%y@%d-%m-%y"},
        {label:"2018/Jan/1-01-2018", format:"%Y@%b@%d-%m-%Y"},
        {label:"01-01-2018", format:"%d-%m-%Y"}
      ],
      show:false
    };
  },
  components:{
    "binCredentials":AddBinCredentails,
    "back-button":BackButton,
    "Multiselect":Multiselect
  },
  methods : {
    toggleUniqueString(){
      this.show = !this.show;
    },
     secBackupIpValidationCheck(){
      if (this.ipAddressRegex.exec(this.secBackupIp) != null){
        this.secondaryValidBackupIp = true;
      } else {
        this.secondaryValidBackupIp = false;
      }
    },
    secIpValidationCheck(){
      if (this.ipAddressRegex.exec(this.secIp) != null){
        this.secondaryValidIp = true;
      } else {
        this.secondaryValidIp = false;
      }
    },
    ipAddressValidationCheck(){
      if (this.ipAddressRegex.exec(this.IpAddress) != null){
        this.validIp = true;
      } else {
        this.validIp = false;
      }
    },
    backupIpAddressValidationCheck(){
      if (this.ipAddressRegex.exec(this.BackupIp) != null){
        this.validBackupIp = true;
      } else {
        this.validBackupIp = false;
      }
    },
    onChange(event){
      this.watchFolderDetails["watch_interval"] = parseInt(event);
    },
    onBinTypeChange(event){
      this.newBinInfo["bin_type"] = event.type;
      this.selectedBinType = event;
    },
    containsKey(obj, key ) {
      return Object.keys(obj).includes(key);
    },
    isValidIP(ipAdd){
      let ipAddressRegex = new RegExp(/^(?:(?:1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)\.){3}(?:1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)$/);
      let domainNameRegex = new RegExp(/^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/);
      if (ipAddressRegex.exec(ipAdd) != null){
        return true;
      }else if(domainNameRegex.exec(ipAdd) != null){
        return true;
      }
      return false;
    },
    validateDetails(protocolType, binShareInfo, isPrimary){
      if(typeof protocolType == "undefined" || protocolType.trim().length <= 0){
        if(isPrimary){
             this.showPrimaryCredentialSection = true
             alert("Please select valid primary protocol. ");
             this.$refs.primaryBinCredentails.setFieldFocus('protocol')
           }else if(Object.keys(binShareInfo).length > 0){
             this.showSecondaryCredentialSection = true
             alert("Please select valid secondary protocol. ");
             this.$refs.secondaryBinCredentails.setFieldFocus('protocol')
           }
           return false
      }
      if(protocolType == 'file'){
        if(!this.containsKey(binShareInfo, 'path') ||
         typeof(binShareInfo['path']) == "undefined" ||
         binShareInfo['path'].trim().length <= 0 ){
           if(isPrimary){
             this.showPrimaryCredentialSection = true
             alert("Please add valid primary credentails file path. ");
             this.$refs.primaryBinCredentails.setFieldFocus('path')
           }else{
             this.showSecondaryCredentialSection = true
             alert("Please add valid secondary credentails file path. ");
             this.$refs.secondaryBinCredentails.setFieldFocus('path')
           }
           return false
         }
      }else if(protocolType == 'ftp' || protocolType == 'smb'){
        if(!this.containsKey(binShareInfo, 'server') ||
        typeof(binShareInfo['server']) == "undefined" ||
        binShareInfo['server'].trim().length <= 0 || !this.isValidIP(binShareInfo['server'])){
          if(isPrimary){
             this.showPrimaryCredentialSection = true
            alert("Please add valid primary Ip. ");
            this.$refs.primaryBinCredentails.setFieldFocus('server')
          }
          else{
             this.showSecondaryCredentialSection = true
            alert("Please add valid secondary Ip. ");
            this.$refs.secondaryBinCredentails.setFieldFocus('server')
          }
          return false
        }
        if(protocolType == 'ftp') {
          if(!this.containsKey(binShareInfo, 'offset_path') ||
            typeof(binShareInfo['offset_path']) == "undefined" ||
            binShareInfo['offset_path'].trim().length <= 0){
             if(isPrimary){
               this.showPrimaryCredentialSection = true
               alert("Please add valid primary credentails offset path. ");
               this.$refs.primaryBinCredentails.setFieldFocus('offset_path')
             }else{
               this.showSecondaryCredentialSection = true
               alert("Please add valid secondary credentails offset path. ");
               this.$refs.secondaryBinCredentails.setFieldFocus('offset_path')
             }
          return false
          }
        }
        else if(protocolType == 'smb'){
          if(!this.containsKey(binShareInfo, 'remote_name') ||
            typeof(binShareInfo['remote_name']) == "undefined" ||
            binShareInfo['remote_name'].trim().length <= 0){
             if(isPrimary){
               this.showPrimaryCredentialSection = true
               alert("Please add valid primary credentails remote name.");
               this.$refs.primaryBinCredentails.setFieldFocus('remote_name')
             }else{
               this.showSecondaryCredentialSection = true
               alert("Please add valid secondary credentails domain. ");
               this.$refs.secondaryBinCredentails.setFieldFocus('remote_name')
             }
           return false
          }
          if(!this.containsKey(binShareInfo, 'workgroup') ||
            typeof(binShareInfo['workgroup']) == "undefined" ||
            binShareInfo['workgroup'].trim().length <= 0){
             if(isPrimary){
               this.showPrimaryCredentialSection = true
               alert("Please add valid primary credentails domain.");
               this.$refs.primaryBinCredentails.setFieldFocus('workgroup')
             }else{
               this.showSecondaryCredentialSection = true
               alert("Please add valid secondary credentails domain. ");
               this.$refs.secondaryBinCredentails.setFieldFocus('workgroup')
             }
           return false
          }
          if(!this.containsKey(binShareInfo, 'sharename') ||
            typeof(binShareInfo['sharename']) == "undefined" ||
            binShareInfo['sharename'].trim().length <= 0){
             if(isPrimary){
               this.showPrimaryCredentialSection = true
               alert("Please add valid primary credentails share name.");
               this.$refs.primaryBinCredentails.setFieldFocus('sharename')
             }else{
               this.showSecondaryCredentialSection = true
               alert("Please add valid secondary credentails share name. ");
               this.$refs.secondaryBinCredentails.setFieldFocus('sharename')
             }
          return false
          }
        }
        if(!this.containsKey(binShareInfo, 'username') ||
        typeof(binShareInfo['username']) == "undefined" ||
        binShareInfo['username'].trim().length <= 0){
          if(isPrimary){
             this.showPrimaryCredentialSection = true
            alert("Please add valid primary username. ");
            this.$refs.primaryBinCredentails.setFieldFocus('username')
          }
          else{
             this.showSecondaryCredentialSection = true
            alert("Please add valid secondary username. ");
            this.$refs.secondaryBinCredentails.setFieldFocus('username')
          }
          return false
        }
        if(!this.containsKey(binShareInfo, 'password') ||
          typeof(binShareInfo['password']) == "undefined" ||
          binShareInfo['password'].trim().length <= 0){
          if(isPrimary){
            this.showPrimaryCredentialSection = true
            alert("Please add valid primary credentails password. ");
            this.$refs.primaryBinCredentails.setFieldFocus('password')
          }else{
            this.showSecondaryCredentialSection = true
            alert("Please add valid secondary credentails password. ");
            this.$refs.secondaryBinCredentails.setFieldFocus('password')
          }
          return false
        }
      }
      return true
    },
    addBin(){
      if(!this.containsKey(this.newBinInfo, "bin_id") ||
        typeof(this.newBinInfo["bin_id"]) == "undefined" ||
        this.newBinInfo["bin_id"].trim().length <= 0){
          alert("Please add valid bin id. ");
          document.getElementById("field_binid").scrollIntoView();
          document.getElementById("binid_value").focus();
          return
       } else if(!this.containsKey(this.newBinInfo, "bin_name") ||
        typeof(this.newBinInfo["bin_name"]) == "undefined" ||
        this.newBinInfo.bin_name.trim().length <= 0){
          alert("Please add valid bin name. ");
          document.getElementById("field_binname").scrollIntoView();
          document.getElementById("binname_value").focus();
          return
       }
       if(this.newBinInfo.bin_type == 'proxy'){
         if(!this.containsKey(this.proxyInfo, "preview_url") ||
          typeof(this.proxyInfo["preview_url"]) == "undefined" ||
          this.proxyInfo["preview_url"].trim().length <= 0){
            alert("Please add valid preview path. ");
            document.getElementById("field_preview_url").scrollIntoView();
            document.getElementById("preview_url_value").focus();
            return
          }
          // else if(!this.containsKey(this.proxyInfo, "supported_bin_types") ||
          // typeof(this.proxyInfo["supported_bin_types"]) == "undefined" ||
          // this.proxyInfo["supported_bin_types"].trim().length <= 0){
          //   alert("Please add valid supported bin types. ");
          //   document.getElementById("field_supported_bin_types").scrollIntoView();
          //   document.getElementById("supported_bin_types_value").focus();
          //   return
          // }
       }
       let proxyDetails = {}
       Object.assign(proxyDetails, this.proxyInfo)
       if(this.newBinInfo.bin_type == 'proxy' &&
        typeof(this.proxyInfo["supported_bin_types"]) != "undefined" &&
         this.proxyInfo["supported_bin_types"].trim().length > 0){
        proxyDetails["supported_bin_types"] = proxyDetails["supported_bin_types"].split(',')
       }else{
         proxyDetails["supported_bin_types"] =[]
       }
       this.newBinInfo["proxy_options"] = proxyDetails

       let primBinShareInfo = this.$refs.primaryBinCredentails.getBinDetails()
       let primProtocolType = this.$refs.primaryBinCredentails.getSlectedProtocol()
       
       let validDetails = this.validateDetails(primProtocolType, primBinShareInfo, true)
       if(!validDetails){
         return
       }
       let secBinShareInfo = this.$refs.secondaryBinCredentails.getBinDetails()
       let secProtocolType = this.$refs.secondaryBinCredentails.getSlectedProtocol()
       if(primProtocolType == secProtocolType && (typeof secBinShareInfo != "undefined" && secBinShareInfo != null &&
       Object.keys(secBinShareInfo).length > 0)){
         alert("Primary and Secondary protocol types cann't be same. \nPlease add different credentials. ");
         return
       }
       let credentialsMap = {}
       let awsCredentialsMap = {}
         this.newBinInfo["protocol_strategy"] = [primProtocolType]
         if(primProtocolType == 'aws'){
          awsCredentialsMap[primProtocolType] = {}
         }else{
          credentialsMap[primProtocolType] = primBinShareInfo
         }
        if(primProtocolType != secProtocolType && typeof secBinShareInfo != "undefined" && secBinShareInfo != null &&
              Object.keys(secBinShareInfo).length > 0){
          validDetails = this.validateDetails(secProtocolType, secBinShareInfo, false)
          if(!validDetails){
           return
          }
          this.newBinInfo["protocol_strategy"].push(secProtocolType)
          if(secProtocolType == 'aws' && this.newBinInfo.protocol_strategy.includes('aws')){
            awsCredentialsMap[secProtocolType] = {}
          }else{
            credentialsMap[secProtocolType] = secBinShareInfo
          }
        }
        if(Object.keys(awsCredentialsMap).length > 0){
          this.newBinInfo.cloud_protocol_credentials = awsCredentialsMap;
        }
       this.newBinInfo.protocol_credentials = credentialsMap
       let watchDetails = {}
       if(typeof(this.watchFolderDetails) != "undefined"){
         watchDetails = this.watchFolderDetails
       }
       let fileTypeDetails = {}
       if(typeof(watchDetails["poll_strategy"]) != "undefined"){
         fileTypeDetails =watchDetails["poll_strategy"]
       }
       if(typeof(this.supportedFileList) == "undefined" ||
       this.supportedFileList.trim().length <= 0){
         this.supportedFileList = "mp4,mpeg,mxf,mov,avi"
       }
       if(this.fileTypesStrategy == "regex_pattern"){
         fileTypeDetails["regex_pattern"] = this.supportedFileList
       }else if(this.fileTypesStrategy == "include_list"){
         fileTypeDetails["include_list"] = this.supportedFileList.split(",")
       }else{
         fileTypeDetails["exclude_list"] = this.supportedFileList.split(",")
       }
       fileTypeDetails["strategy"] = this.fileTypesStrategy
       watchDetails["poll_strategy"] = fileTypeDetails

      if(this.appendUniqueString){
        let uniqueStrategy = {}
        uniqueStrategy["strategy"] = this.uniqueStringStrategy
        watchDetails["unique_string"] = uniqueStrategy
        watchDetails["attach_unique_string"] = this.appendUniqueString
      }

      if(this.watchFolderDetails.status && this.watchPath.trim() == ""){
        alert("Empty Watch Folder name")
        this.$refs.watchFolderName.focus();
        return false;
      }
      watchDetails["watch_path"] = this.watchPath.trim();

      if(this.watchFolderDetails.status && this.outPath.trim() == ""){
        alert("To save Empty Out Folder, please type 'EMPTY' and save")
        this.$refs.outFolderName.focus();
        return false;
      }
      watchDetails["pass_path"] = this.outPath.trim();
      watchDetails["error_path"] = this.errorPath
      watchDetails["watch_interval"] = this.watchInterval
      if(this.watchFolderDetails.create_pass_path_datewise){
        watchDetails["pass_path_datewise_format"] = this.watchPassPathDateStruct.format
      }
      this.watchFolderDetails = watchDetails
      if(this.watchFolderDetails.status){
        this.newBinInfo["watch_options"] = this.watchFolderDetails
      }else{
        this.newBinInfo["watch_options"] = {
          status:this.watchFolderDetails.status,
          // watch_path:"INBOX",
          // pass_path:"ONAIR",
          watch_path:this.watchPath,
          error_path:"ERROR",
          pass_path:this.outPath,
          attach_unique_string:false,
          watch_interval:10,
          create_pass_path_datewise:false,
          keep_watch_path_structure :false,
        }
      }
      this.newBinInfo["logical"] = false
      this.newBinInfo["archive_options"] = this.advancedOptions;
      if(typeof(this.newBinInfo) != "undefined"){
        this.addNewBin(this.newBinInfo).then((data) => {
          if (Utils.isAcceptedStatusCode(data.statusCode)){
            this.$toast.success(data.message);
            this.changeToSelectedBinComponent("show-bins");
          } else {
            this.$toast.error(data.message);
          }
        });
      }
    },
    changeToSelectedBinComponent(compName, payload={}){
      this.$emit("changeToSelectedBinComponent", compName, payload)
    },
      ...mapActions("bins",["addNewBin"])
  },
  watch: {
    'show': function (val) {
      if (val) {
          this.$nextTick(() => {
          this.$refs.binIdRef.focus()
        })
      }
    }
  },
  mounted(){
    setTimeout(() => {
      this.show = true;
    }, 200);
  }
};
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $button-height:38px;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;


.comm-input-field-style{
    background: $primary-background!important;
    width: 100% !important;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: $input-field-height;
}

h6 {
   width: 100%; 
   text-align: center; 
   line-height: 0.1em;
   margin: 10px 0 20px; 
} 

h6 span { 
    background:$text-color; 
    padding:0 10px; 
}

.bins-basic-info-table{
  font-size: 15px;
  tbody {
    margin: 10px;
    .key-div {
      text-align: end;
      color: $dull-text-color;
      width:20%;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px;
      width:38%;
    }
  }
}

.btn {
  font-size: 14px !important;
  height: 100%;
}

.border {
  border: $border-color !important;
}
.activeclass {
  color: $active-blue;
}

.nav-item{
  width:15%;
  color: $dull-text-color !important;
}
.inactiveNav:hover{
  color:$text-color !important;
}
.activeNav{
    background: $primary-background !important;
    font-size:15px;
    font-weight:500;
    color:$active-blue  !important;
    border-bottom: 2px solid $active-blue;
}
table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: none !important;
      border-bottom: none !important;
    }
  }
  tbody {
    color: $text-color;
    td {
      border-top: none !important;
    }
  }
}

table.bins-basic-info-table .editIcon {
  visibility: hidden;
}
table.bins-basic-info-table td.value-div:hover .editIcon {
  visibility: visible;
}

input[type="radio"] {
    /* background-color only for content */
    background-color:$primary-background !important;
  }
  
  /* appearance for checked radiobutton */
  input[type="radio"]:checked {
    background-color: $active-blue !important;
    //background-image: linear-gradient(to bottom, #5294ce, #3176b3) !important;
    background: radial-gradient(circle, $active-blue 40%, $primary-background 49%, $primary-background 100%) !important;
    border: $secondary-border-color !important;
  }

input[type='checkbox']:after{
    line-height: 1.5em;
    content: '';
    display: inline-block;
    width: 22px;
    height: 21px;
    margin-top: 5px;
    margin-inline-start: -1px;
    border: $border-color;
    border-radius: 0.25em;
    background: $primary-background;
}

input[type='checkbox']:checked:after{
    content: '✔';
    color: $active-blue !important;
    // position: absolute;
    font-size: 16px;
    line-height: 1;
    transition: all .2s;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px;
    padding-top:2px;
}

.bigger-checkboxes{
    height: 30px;
    width: 20px;
}

input[type="radio"] {
    outline: none !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline-block;
    padding: 4px;
    border-radius: 50% !important;
    width: 20px;
    height: 20px;
}

.navbar{
  background: $primary-background;
}
.custom-control-label::before {
  background-color: $primary-background;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

input[type='checkbox']:after{
    line-height: 1.5em;
    content: '';
    display: inline-block;
    width: 22px;
    height: 21px;
    margin-top: 5px;
    margin-inline-start: -1px;
    border: $border-color;
    border-radius: 0.25em;
    background: $primary-background;
}

input[type='checkbox']:checked:after{
    content: '✔';
    color: $active-blue !important;
    font-size: 16px;
    line-height: 1;
    transition: all .2s;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px;
    padding-top:2px;
}

.bigger-checkboxes{
    height: 30px;
    width: 20px;
}

.validationmessage{
  color:$danger-color;
  font-size: 11px;
}

.tabcontent{
    position: absolute;
    width: 100%;
    height: calc(100% - 140px);
    overflow: auto;
}

.breadcrumb{
  padding: .75rem 1rem !important;
  background: $primary-background !important;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}

.secondary-btn-style{
  color:$text-color;
}

.secondary-btn-style:hover{
  text-decoration: underline;
}

.primary-btn-style {
  margin-top: 1%;
  position: absolute;
  bottom: 6px;
  inset-inline-end: 0%;
  height:50px;
  background: $primary-background;
  width:100%;
  z-index:9;
  button {
    height: $button-height;
    width: 70px;
    font-size:14px;
    margin-top:7px;
  }
  .btn-outline-secondary{
    float:inline-end;
  }
  .btn-outline-primary{
    float:inline-end;
    margin-inline-end:15px;
  }
}

.config-desc{
  color: $dull-text-color;
}
::v-deep{
    .multiselect{
        width:100%;
        margin: 3px 0px;
    }
    .multiselect__tags-wrap{
        display:block;
    }
    .multiselect__content-wrapper{
        display:none;
    }
    .multiselect__tag, .tags-style {
        background-color: $primary-background !important;
        border: $border-color;
        border-radius: 5px;
        margin-bottom:0px;
    }
    .multiselect__tags, .tags-style {
        background: $primary-background !important;
        border: $border-color !important;
    }
    .multiselect__option--highlight {
        background: $bg-color-on-hover !important;
    }
    .multiselect__content {
        background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__input:focus{
        outline:none;
        box-shadow: none;
    }
    .multiselect__tag-icon{
    color:$text-color;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color: $text-color !important;
    }
    .multiselect__tag-icon:after{
    color:$secondary-text-color !important;
    font-size: 20px;
    }
    .multiselect *{
        font-size: $input-field-and-label-font-size;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect__tags{
        padding: 8px 35px 0 8px !important;
    }

    .multiselect__select{
        width:35px !important;
    }
    
    .multiselect__placeholder {
        // padding-top: 5px !important;
        margin-bottom:0px;
        color:#5d5d5d !important;
    }
    .multiselect{
        color:$text-color !important;
        font-size: $input-field-and-label-font-size !important;
        min-height: 36px;
    }
    .multiselect__single{
            margin: 0!important;
            height: 100%;
            display: flex;
            align-items: center;
    }
    .multiselect__option--selected{
        background:$bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid $bg-color-on-hover !important;
        position: absolute;
        display: block;
        background: $text-color;
        width: 100% !important;
        max-height: 150px;
        overflow: auto;
        border: 1px solid $text-color;
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        z-index: 50;
        -webkit-overflow-scrolling: touch;
        // width:auto !important;
    }

    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
    background: $secondary-background-color !important;
    }
    .multiselect__tags {
        background: $primary-background !important;
        height: auto;
    }

}

</style>